export default "__VITE_ASSET__D4g7qk$M__"